export default {"src":"/_next/static/media/icon_signout.15f7e5a1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};